import ParticlesPreloader from '@/scripts/elements/ParticlesPreloader';
import { DOCUMENT_ELEMENT } from '@/scripts/constants';
import { TweenLite } from 'gsap/TweenMax';
import '@/scripts/lettering-surrogate-pairs';
import ScrollMagic from 'scrollmagic';
import Controller from '@/scripts/utils/scrollmagic/controller';
import _debounce from 'lodash/debounce';
import './History.scss';

const defaults = {
  container: '[data-role="history-container"]',
  preloader: '[data-role="history-preloader"]',
  step: '[data-role="history-step"]',
  stepsContainer: '[data-role="history-steps"]',
};

export default class History {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.containerElement = document.querySelector(options.container);
    this.preloaderElement = document.querySelector(options.preloader);
    this.stepSelector = options.step;
    this.stepsContainer = document.querySelector(options.stepsContainer);

    if (!this.containerElement || !this.preloaderElement) return;

    this.steps = [];
    this.scenes = [];
    this.preloader = null;
    this.init();
  }

  scroll() {
    this.scenes = Array.from(document.querySelectorAll(this.stepSelector)).map((step) => {
      const scene = new ScrollMagic.Scene({
        triggerElement: step,
        duration: step.offsetHeight,
      })
        .on('enter', () => {
          this.steps[step.dataset.index].addClass('is-active');
        })
        .on('leave', () => {
          this.steps[step.dataset.index].removeClass('is-active');
        })
        .addTo(Controller);

      window.addEventListener('resize', _debounce(() => {
        scene.duration(step.offsetHeight);
      }));

      return scene;
    });
  }

  createTextes() {
    this.containerElement.querySelectorAll(this.stepSelector).forEach((step) => {
      const $stepText =
        $(`
            <div class="history-steps__item" data-split-text="letters-only">${step.dataset.step}</div>
          `);
      this.steps.push($stepText);
    });
    $(this.stepsContainer).append(this.steps);
    $(this.stepsContainer).find('[data-split-text="letters-only"]').each(function trim() {
      const text = $(this).text();
      $(this).text($.trim(text)).lettering();
    });
  }

  init() {
    this.preloader = new ParticlesPreloader({
      element: this.preloaderElement,
      container: this.containerElement,
    });
    this.createTextes();
    DOCUMENT_ELEMENT.addEventListener('preloaderEnd', () => {
      this.preloader.play();
    });
    DOCUMENT_ELEMENT.addEventListener('historyReady', () => {
      this.containerElement.classList.add('is-active');
      this.scroll();
      if ($(window).scrollTop() < 300) {
        TweenLite.to(window, 1, { scrollTo: { y: 350, autoKill: false } });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/elements/History/History.js